import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function WhyChooseUs() {
  const { t } = useTranslation();
  const [active, setActive] = useState(0);

  const whyChoose = [
    { icon: "ri-shield-check-line", title: t("why.w1title"), text: t("why.w1text") },
    { icon: "ri-money-dollar-circle-line", title: t("why.w2title"), text: t("why.w2text") },
    { icon: "ri-file-shield-2-line", title: t("why.w3title"), text: t("why.w3text") },
    { icon: "ri-truck-line", title: t("why.w4title"), text: t("why.w4text") },
  ];

  const values = [
    { label: t("why.v1label"), text: t("why.v1text") },
    { label: t("why.v2label"), text: t("why.v2text") },
    { label: t("why.v3label"), text: t("why.v3text") },
    { label: t("why.v4label"), text: t("why.v4text") },
  ];

  const testimonials = [
    { text: t("why.t1text"), name: t("why.t1name"), location: t("why.t1loc") },
    { text: t("why.t2text"), name: t("why.t2name"), location: t("why.t2loc") },
    { text: t("why.t3text"), name: t("why.t3name"), location: t("why.t3loc") },
    { text: t("why.t4text"), name: t("why.t4name"), location: t("why.t4loc") },
  ];

  return (
    <section className="w-full bg-white">
      {/* Why choose us */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16">
        <div className="text-center">
          <span className="text-xs font-medium uppercase tracking-widest text-brand-gold">
            {t("why.promise")}
          </span>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl font-semibold uppercase text-brand-dark">
            {t("why.title")}
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {whyChoose.map((w) => (
            <div key={w.title} className="rounded-lg border border-neutral-200 bg-neutral-50 p-6 text-center">
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-brand-dark text-brand-gold">
                <i className={`${w.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold uppercase text-brand-dark">{w.title}</h3>
              <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{w.text}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Mission & values */}
      <div className="w-full bg-neutral-50 py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold uppercase text-brand-dark">
                {t("why.missionTitle")}
              </h2>
              <p className="mt-4 text-sm md:text-base text-neutral-600 leading-relaxed">
                {t("why.missionText")}
              </p>
            </div>
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold uppercase text-brand-dark">
                {t("why.valuesTitle")}
              </h2>
              <ul className="mt-4 space-y-3">
                {values.map((v) => (
                  <li key={v.label} className="text-sm md:text-base text-neutral-600 leading-relaxed">
                    <span className="font-semibold text-brand-dark">{v.label}</span> – {v.text}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials */}
      <div className="w-full bg-brand-gold py-16">
        <div className="mx-auto max-w-4xl px-4 md:px-6">
          <div className="text-center">
            <i className="ri-double-quotes-l text-4xl text-brand-dark/40"></i>
            <p className="mt-2 font-heading text-xl md:text-2xl font-medium text-brand-dark leading-relaxed">
              &quot;{testimonials[active].text}&quot;
            </p>
            <div className="mt-5">
              <p className="font-heading text-sm font-semibold uppercase text-brand-dark">
                {testimonials[active].name}
              </p>
              <p className="text-xs text-brand-dark/70">{testimonials[active].location}</p>
            </div>
            <div className="mt-6 flex items-center justify-center gap-2">
              {testimonials.map((tItem, i) => (
                <button
                  key={tItem.name}
                  onClick={() => setActive(i)}
                  className={`h-2 rounded-full transition-all ${
                    i === active ? "w-8 bg-brand-dark" : "w-2 bg-brand-dark/30"
                  }`}
                  aria-label={`Testimonial ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}